/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkviewsRouteImport } from './routes/workviews'
import { Route as StorageRouteImport } from './routes/storage'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SchedulesRouteImport } from './routes/schedules'
import { Route as ReconcileRouteImport } from './routes/reconcile'
import { Route as QueryRouteImport } from './routes/query'
import { Route as ProvenanceRouteImport } from './routes/provenance'
import { Route as ProjectionsRouteImport } from './routes/projections'
import { Route as OntologyRouteImport } from './routes/ontology'
import { Route as ObservationsRouteImport } from './routes/observations'
import { Route as IntentsRouteImport } from './routes/intents'
import { Route as FactsRouteImport } from './routes/facts'
import { Route as EventsRouteImport } from './routes/events'
import { Route as EffectsRouteImport } from './routes/effects'
import { Route as DesignRouteImport } from './routes/design'
import { Route as CommandsRouteImport } from './routes/commands'
import { Route as CloudRouteImport } from './routes/cloud'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'

const WorkviewsRoute = WorkviewsRouteImport.update({
  id: '/workviews',
  path: '/workviews',
  getParentRoute: () => rootRouteImport,
} as any)
const StorageRoute = StorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulesRoute = SchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => rootRouteImport,
} as any)
const ReconcileRoute = ReconcileRouteImport.update({
  id: '/reconcile',
  path: '/reconcile',
  getParentRoute: () => rootRouteImport,
} as any)
const QueryRoute = QueryRouteImport.update({
  id: '/query',
  path: '/query',
  getParentRoute: () => rootRouteImport,
} as any)
const ProvenanceRoute = ProvenanceRouteImport.update({
  id: '/provenance',
  path: '/provenance',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectionsRoute = ProjectionsRouteImport.update({
  id: '/projections',
  path: '/projections',
  getParentRoute: () => rootRouteImport,
} as any)
const OntologyRoute = OntologyRouteImport.update({
  id: '/ontology',
  path: '/ontology',
  getParentRoute: () => rootRouteImport,
} as any)
const ObservationsRoute = ObservationsRouteImport.update({
  id: '/observations',
  path: '/observations',
  getParentRoute: () => rootRouteImport,
} as any)
const IntentsRoute = IntentsRouteImport.update({
  id: '/intents',
  path: '/intents',
  getParentRoute: () => rootRouteImport,
} as any)
const FactsRoute = FactsRouteImport.update({
  id: '/facts',
  path: '/facts',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const EffectsRoute = EffectsRouteImport.update({
  id: '/effects',
  path: '/effects',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const CommandsRoute = CommandsRouteImport.update({
  id: '/commands',
  path: '/commands',
  getParentRoute: () => rootRouteImport,
} as any)
const CloudRoute = CloudRouteImport.update({
  id: '/cloud',
  path: '/cloud',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/activity': typeof ActivityRoute
  '/agents': typeof AgentsRoute
  '/cloud': typeof CloudRoute
  '/commands': typeof CommandsRoute
  '/design': typeof DesignRoute
  '/effects': typeof EffectsRoute
  '/events': typeof EventsRoute
  '/facts': typeof FactsRoute
  '/intents': typeof IntentsRoute
  '/observations': typeof ObservationsRoute
  '/ontology': typeof OntologyRoute
  '/projections': typeof ProjectionsRoute
  '/provenance': typeof ProvenanceRoute
  '/query': typeof QueryRoute
  '/reconcile': typeof ReconcileRoute
  '/schedules': typeof SchedulesRoute
  '/settings': typeof SettingsRoute
  '/storage': typeof StorageRoute
  '/workviews': typeof WorkviewsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/activity': typeof ActivityRoute
  '/agents': typeof AgentsRoute
  '/cloud': typeof CloudRoute
  '/commands': typeof CommandsRoute
  '/design': typeof DesignRoute
  '/effects': typeof EffectsRoute
  '/events': typeof EventsRoute
  '/facts': typeof FactsRoute
  '/intents': typeof IntentsRoute
  '/observations': typeof ObservationsRoute
  '/ontology': typeof OntologyRoute
  '/projections': typeof ProjectionsRoute
  '/provenance': typeof ProvenanceRoute
  '/query': typeof QueryRoute
  '/reconcile': typeof ReconcileRoute
  '/schedules': typeof SchedulesRoute
  '/settings': typeof SettingsRoute
  '/storage': typeof StorageRoute
  '/workviews': typeof WorkviewsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/activity': typeof ActivityRoute
  '/agents': typeof AgentsRoute
  '/cloud': typeof CloudRoute
  '/commands': typeof CommandsRoute
  '/design': typeof DesignRoute
  '/effects': typeof EffectsRoute
  '/events': typeof EventsRoute
  '/facts': typeof FactsRoute
  '/intents': typeof IntentsRoute
  '/observations': typeof ObservationsRoute
  '/ontology': typeof OntologyRoute
  '/projections': typeof ProjectionsRoute
  '/provenance': typeof ProvenanceRoute
  '/query': typeof QueryRoute
  '/reconcile': typeof ReconcileRoute
  '/schedules': typeof SchedulesRoute
  '/settings': typeof SettingsRoute
  '/storage': typeof StorageRoute
  '/workviews': typeof WorkviewsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/activity'
    | '/agents'
    | '/cloud'
    | '/commands'
    | '/design'
    | '/effects'
    | '/events'
    | '/facts'
    | '/intents'
    | '/observations'
    | '/ontology'
    | '/projections'
    | '/provenance'
    | '/query'
    | '/reconcile'
    | '/schedules'
    | '/settings'
    | '/storage'
    | '/workviews'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/activity'
    | '/agents'
    | '/cloud'
    | '/commands'
    | '/design'
    | '/effects'
    | '/events'
    | '/facts'
    | '/intents'
    | '/observations'
    | '/ontology'
    | '/projections'
    | '/provenance'
    | '/query'
    | '/reconcile'
    | '/schedules'
    | '/settings'
    | '/storage'
    | '/workviews'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/activity'
    | '/agents'
    | '/cloud'
    | '/commands'
    | '/design'
    | '/effects'
    | '/events'
    | '/facts'
    | '/intents'
    | '/observations'
    | '/ontology'
    | '/projections'
    | '/provenance'
    | '/query'
    | '/reconcile'
    | '/schedules'
    | '/settings'
    | '/storage'
    | '/workviews'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  ActivityRoute: typeof ActivityRoute
  AgentsRoute: typeof AgentsRoute
  CloudRoute: typeof CloudRoute
  CommandsRoute: typeof CommandsRoute
  DesignRoute: typeof DesignRoute
  EffectsRoute: typeof EffectsRoute
  EventsRoute: typeof EventsRoute
  FactsRoute: typeof FactsRoute
  IntentsRoute: typeof IntentsRoute
  ObservationsRoute: typeof ObservationsRoute
  OntologyRoute: typeof OntologyRoute
  ProjectionsRoute: typeof ProjectionsRoute
  ProvenanceRoute: typeof ProvenanceRoute
  QueryRoute: typeof QueryRoute
  ReconcileRoute: typeof ReconcileRoute
  SchedulesRoute: typeof SchedulesRoute
  SettingsRoute: typeof SettingsRoute
  StorageRoute: typeof StorageRoute
  WorkviewsRoute: typeof WorkviewsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workviews': {
      id: '/workviews'
      path: '/workviews'
      fullPath: '/workviews'
      preLoaderRoute: typeof WorkviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storage': {
      id: '/storage'
      path: '/storage'
      fullPath: '/storage'
      preLoaderRoute: typeof StorageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedules': {
      id: '/schedules'
      path: '/schedules'
      fullPath: '/schedules'
      preLoaderRoute: typeof SchedulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reconcile': {
      id: '/reconcile'
      path: '/reconcile'
      fullPath: '/reconcile'
      preLoaderRoute: typeof ReconcileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/query': {
      id: '/query'
      path: '/query'
      fullPath: '/query'
      preLoaderRoute: typeof QueryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provenance': {
      id: '/provenance'
      path: '/provenance'
      fullPath: '/provenance'
      preLoaderRoute: typeof ProvenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projections': {
      id: '/projections'
      path: '/projections'
      fullPath: '/projections'
      preLoaderRoute: typeof ProjectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ontology': {
      id: '/ontology'
      path: '/ontology'
      fullPath: '/ontology'
      preLoaderRoute: typeof OntologyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/observations': {
      id: '/observations'
      path: '/observations'
      fullPath: '/observations'
      preLoaderRoute: typeof ObservationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intents': {
      id: '/intents'
      path: '/intents'
      fullPath: '/intents'
      preLoaderRoute: typeof IntentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facts': {
      id: '/facts'
      path: '/facts'
      fullPath: '/facts'
      preLoaderRoute: typeof FactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/effects': {
      id: '/effects'
      path: '/effects'
      fullPath: '/effects'
      preLoaderRoute: typeof EffectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/commands': {
      id: '/commands'
      path: '/commands'
      fullPath: '/commands'
      preLoaderRoute: typeof CommandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cloud': {
      id: '/cloud'
      path: '/cloud'
      fullPath: '/cloud'
      preLoaderRoute: typeof CloudRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  ActivityRoute: ActivityRoute,
  AgentsRoute: AgentsRoute,
  CloudRoute: CloudRoute,
  CommandsRoute: CommandsRoute,
  DesignRoute: DesignRoute,
  EffectsRoute: EffectsRoute,
  EventsRoute: EventsRoute,
  FactsRoute: FactsRoute,
  IntentsRoute: IntentsRoute,
  ObservationsRoute: ObservationsRoute,
  OntologyRoute: OntologyRoute,
  ProjectionsRoute: ProjectionsRoute,
  ProvenanceRoute: ProvenanceRoute,
  QueryRoute: QueryRoute,
  ReconcileRoute: ReconcileRoute,
  SchedulesRoute: SchedulesRoute,
  SettingsRoute: SettingsRoute,
  StorageRoute: StorageRoute,
  WorkviewsRoute: WorkviewsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
